import React from 'react'
import { GatewayList } from './list/page'

export const GatewayPage = (): JSX.Element => {
  return <GatewayList></GatewayList>
}
